<template>
  <b-modal
    id="expired_package"
    ref="expired_package"
    hide-footer>
    <div class="success-modal">
      <img src="../../assets/img/waring.png">
      <div>
        Rất tiếc gói dịch vụ tư vấn phong thuỷ theo ngày đã hết hạn. Bạn vui lòng gia hạn để tiếp tục sử dụng dịch vu!!!
      </div>
      <div>
        <button
          class="btn btn-success"
          @click="redirectToByPackage()">GIA HẠN</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "ExpiredPackage",
        methods: {
            redirectToByPackage() {
                this.$router.push('upgrade-account');
            }
        }
    }
</script>

<style lang="scss" scoped>
  .success-modal {
    text-align: center;
    padding: 16px;

    img {
      display: table-cell;
      object-fit: cover;
      margin: auto auto 16px;
    }

    > div {
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #4A4A4A;

      &:last-child {
        margin-top: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/luan-giai-tuoi/ExpiredPackage.vue